import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { sendFile } from 'store/messages/messages.actions';

type ReturnType = [boolean, boolean, number, (data: File, attributeName?: string) => Promise<void>];

const useUpload = (onError: (text: string) => void): ReturnType => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [progress] = useState(0);

    const dispatch = useDispatch();

    const upload = useCallback(
        async (file: File) => {
            if (loading) return;
            setLoading(true);
            setError(false);

            try {
                dispatch(sendFile({
                    file,
                    fileName: file.name,
                }))
            } catch (err) {
                setError(true);
                console.log(err);
                onError((err as any).response?.data);
            }

            setLoading(false);
        },
        [loading, dispatch, onError]
    );

    return [loading, error, progress, upload];
};

export default useUpload;
